<template>
  <article class="page page--news-item page--spaced">
    <Loader :loading="isLoading">
      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell small-12 medium-8 large-7 small-order-2 medium-order-1">
            <Rich v-if="newsItem" :article="newsItem" class="news-item--content" />
          </div>
          <aside class="cell medium-4 large-offset-1 small-order-1 medium-order-2">
            <ArticleDate :date="$get(newsItem, 'data.date', null)" />

            <Loader v-show="$device.isMedium" :loading="areItemsLoading" spinner-size="sm">
              <ul class="news-items-menu">
                <li>
                  <h3>{{ $t('aside.heading') }}</h3>
                </li>
                <li v-for="item in menuItems" :key="item.id">
                  <p>{{ item | newsItemDate }}</p>
                  <nuxt-link :to="item | newsItemURI">
                    {{ item | articleTitle }}
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link :to="{ name: 'cms:news' }">
                    {{ $t('aside.actions.viewAll.label') }}<!--
                    --><FontAwesomeIcon :icon="['fac', 'chevron-right-light']" />
                  </nuxt-link>
                </li>
              </ul>
            </Loader>
          </aside>
        </div>
      </div>
    </Loader>
  </article>
</template>

<script>
  import { facChevronRightLight } from '~/assets/font-awesome-custom/fac-chevron-right-light'
  import ArticleDate from '~/components/frontend/article-date'
  import Page from '~/components/frontend/page'
  import Loader from '~/libs/queue/components/frontend/loader'
  import Rich from '~/modules/cms/components/templates/rich'
  import CMSFilters from '~/modules/cms/filters'
  import { date as formatDate } from '~/utils/filters'
  import i18n from './locales'

  export default {
    name: 'Item',
    extends: Page,
    i18n,
    components: {
      ArticleDate,
      Loader,
      Rich,
    },
    filters: {
      ...CMSFilters,
      formatDate,
    },
    data () {
      return {
        areItemsLoading: false,
        isLoading: false,
      }
    },
    computed: {
      menuItems () {
        const items = Array.isArray(this.newsItems) ? this.newsItems : []

        return items.slice(0, 3)
      },
      newsItem () {
        return this.$store.getters['cms/newsItem']
      },
      newsItems () {
        return this.$store.getters['cms/newsItems']
      },
      subheader () {
        return {
          heading: CMSFilters.articleTitle(this.newsItem),
          extraClasses: 'news-item-sub-header',
        }
      },
    },
    methods: {
      async fetchNewsItem () {
        try {
          this.isLoading = true
          await this.$store.dispatch('cms/fetchNewsItem', this.$get(this.$route, 'params.id'))
        } catch (err) {
          this.$sentry.captureException(err)
        } finally {
          this.isLoading = false
        }
      },
      async fetchNewsItems () {
        if (Array.isArray(this.newsItems) && this.newsItems.length > 0) return

        try {
          this.areItemsLoading = true
          await this.$store.dispatch('cms/fetchNews', { page: 1 })
        } catch (err) {
          this.$sentry.captureException(err)
        } finally {
          this.areItemsLoading = false
        }
      },
    },
    created () {
      this.fetchNewsItem()
      this.fetchNewsItems()

      this.$fa.add(facChevronRightLight)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~assets/scss/frontend/_fonts";
  @import "~assets/scss/frontend/_settings";
  @import "~foundation-sites/scss/global";

  .page--news-item {
    .news-items-menu {
      background: $colour-magnolia-light;
      list-style-type: none;
      margin: 0;
      padding: 0;

      li {
        border: {
          bottom: $global-border;
          left: $global-border;
          right: $global-border;
        }
        padding: rem-calc(15);

        &:first-child {
          border-top: $global-border;
        }
      }
    }
  }
</style>
